"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _select = require("./select");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
const Select = props => {
  const [open, setOpen] = (0, _react.useState)(false);
  const ref = (0, _react.useRef)(null);
  const onBackgroundClick = e => {
    var _e$target;
    e === null || e === void 0 ? void 0 : e.preventDefault();
    if (ref.current === e.target || ((_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.getAttribute('name')) === props.name) {
      return;
    }
    unmount();
    setOpen(false);
  };
  const onKeyPress = e => {
    // close the dropdown on enter if it's open
    if ((e === null || e === void 0 ? void 0 : e.code) === 'Enter' && open) {
      e === null || e === void 0 ? void 0 : e.preventDefault();
      unmount();
      setOpen(false);
    }
  };
  const unmount = () => {
    window.removeEventListener('click', onBackgroundClick);
    window.removeEventListener('keyup', onKeyPress);
  };
  (0, _react.useEffect)(() => unmount, []); // eslint-disable-line react-hooks/exhaustive-deps

  const onClick = e => {
    e === null || e === void 0 ? void 0 : e.preventDefault();
    if (open) {
      unmount();
      setOpen(false);
      return;
    }
    window.addEventListener('click', onBackgroundClick);
    window.addEventListener('keyup', onKeyPress);
    setOpen(true);
  };
  return /*#__PURE__*/_react.default.createElement(_select.Select, (0, _extends2.default)({}, props, {
    open: open,
    innerRef: ref,
    onClicks: {
      trigger: onClick,
      option: onClick
    }
  }));
};
var _default = exports.default = Select;